export enum TariffType {
  Simple = 'simple',
  Dual = 'dual',
  NightExclusive = 'nightExclusive'
}
